import URI from 'urijs';
import AgGridPagination from '../components/ag_grid_pagination';
import AgGridColumnFilters from '../components/ag_grid_column_filters';
import * as infiniteHits from '../../search/load_more_results';
import { showModalFromUrl, initializeSaveSearch } from '../../search/search_helpers';
import { safeAddWidgets } from '../../search/base_widgets';
window.IndexSnapshotSaver = require('../components/index_snapshot_saver');

window.WorkplaceTenders = {
  _gridOptions: null,
  _initCall: true,
  _rolePriority: ['executive_officer', 'evaluator', 'auditor', 'verifier', 'documenter', 'bidder'],

  emptyCallHandler() {
    if (this._initCall) {
      $('.search-results-container').hide();
      $('#spinner').hide();
      return $('.empty-page').removeClass('hidden');
    }
  },

  reloadData(data) {
    this._initCall = false;

    // Apply Open RFCs filter if active (for table view)
    if (window.openRfcsFilterActive && data) {
      data = data.filter(tender => {
        return this._shouldShowTenderWithOpenRfcsFilter(tender);
      });
    }

    this._gridApi.setGridOption('rowData', data);
    $('#tenders-grid').parent().removeClass('hidden');
    $('.actions').removeClass('hidden');
    $('#spinner').hide();
    return this._resizeTable();
  },

  _resizeTable() {
    return resizeAgGridTable('#tenders-table', { api: this._gridApi }, 1, this._currentDataSize, 48);
  },

  _initializeCookieSavers(preloadedCookies, path) {
    const cookieNames = [
      'tenders-table-column-order',
      'tenders-table-column-filters',
      'tenders-table-group-filters',
    ];

    return IndexSnapshotSaver.initialize(cookieNames, preloadedCookies, path).startSaving();
  },

  _initializeWidgets(app_id, key, index) {
    const widgets = [
      () => WorkplaceWidgets.phaseWidget(),
      () => WorkplaceWidgets.biddingPeriodWidget(),
      () => WorkplaceWidgets.projectCreatedAtPeriodWidget(),
      () => WorkplaceWidgets.tenderCreatedAtPeriodWidget(),
      () => WorkplaceWidgets.latestRfcCreatedAtPeriodWidget(),
      () => WorkplaceWidgets.latestRfcCommentCreatedAtPeriodWidget(),
      () => WorkplaceWidgets.developersWidget(),
      () => WorkplaceWidgets.biddersWidget(),
      () => WorkplaceWidgets.auditorsWidget(),
      () => WorkplaceWidgets.evaluatorsWidget(),
      () => WorkplaceWidgets.sectorsWidget(),
      () => WorkplaceWidgets.ownersWidget(),
      () => WorkplaceWidgets.verifiersWidget(),
      () => WorkplaceWidgets.invitedBiddersWidget(),
      () => WorkplaceWidgets.acceptedBiddersWidget(),
      () => WorkplaceWidgets.receivedBidsWidget(),
      () => Widgets.statsWidget(),
      () => Widgets.currentRefinedValuesWidget()({ excludedAttributes: [] }),
      () => Widgets.searchBoxWidget(I18n.t('v4.tenders.filters.enter_keyword')),
      () => WorkplaceWidgets.descriptionWidget(),
      () => Widgets.clearAllWidget(),
      () => Widgets.saveSearchWidget(),
      () => WorkplaceWidgets.stateWidget(['Draft', 'Pending', 'Posted', 'On Hold', 'Opened', 'Awarded', 'Cancelled'])
    ];

    // Add RFC filter with role-aware attribute selection
    if ($('#open-rfcs').length > 0) {
      const userRole = this._getCurrentUserRoleFromPage();
      widgets.push(() => WorkplaceWidgets.hasOpenRfcsWidget(userRole));
    }

    widgets.push(() => WorkplaceWidgets.evaluationStateWidget());
    safeAddWidgets(this._tenderSearch, widgets);
  },

  // Get current user's role from page data or detect from search results
  // Considers admin status when determining role priority
  _getCurrentUserRoleFromPage() {
    // Check if role is already cached
    if (window.currentUserRole) {
      return window.currentUserRole;
    }

    // Get roles from server-side data (set before widget initialization)
    if (window.currentUserCompanyRoles && window.currentUserCompanyRoles.length > 0) {
      // Use role priority to select highest priority role
      const rolePriority = ['executive_officer', 'evaluator', 'auditor', 'verifier', 'documenter', 'bidder'];
      for (const role of rolePriority) {
        if (window.currentUserCompanyRoles.includes(role)) {
          window.currentUserRole = role;
          return role;
        }
      }
    }

    // Fallback: Try to detect from first search result (for when server data not available)
    const currentUserId = window.currentUserId;
    if (!currentUserId) {
      return null;
    }

    const self = this;
    const detectRoleFromResults = () => {
      // This will be called after first search result loads
      let firstResult = null;
      if (self._gridOptions && self._gridOptions.api) {
        const row = self._gridOptions.api.getDisplayedRowAtIndex(0);
        if (row) {
          firstResult = row.data;
        }
      }

      if (firstResult && firstResult.roles_with_users) {
        // Check if user is admin - this affects role eligibility
        const isAdmin = self._isUserAdmin(firstResult.company_admin_or_auditor_ids);

        // Find highest priority role considering admin status
        const detectedRole = self._findCurrentUserRole(firstResult.roles_with_users, isAdmin);
        if (detectedRole) {
          window.currentUserRole = detectedRole;
          return detectedRole;
        }
      }
      return null;
    };

    // Try to detect immediately if results are available
    return detectRoleFromResults();
  },

  _initializeSaveSearch() {
    initializeSaveSearch({
      type: 'tenders',
      editSelector: '#add-drop a.edit',
      showSignInModal: false
    });
  },

  _tenderUrl(data) {
    if (this._isExecutiveOfficer(data) && (data.state !== 'draft')) {
      return `/workplace/tenders/${data.id}/show_post`;
    } else if (this._isBidder(data) && data.bid && _.contains(['on_hold', 'opened', 'awarded', 'no_awarded'], data.state)) {
      return `/workplace/tenders/${data.id}/bids/${data.bid.id}/summary`;
    } else if (data.document_set_present && !(this._isEvaluator(data) && (data.state !== 'opened'))) {
      return `/workplace/tenders/${data.id}/document_sets`;
    } else {
      return `/workplace/tenders/${data.id}`;
    }
  },

  _isExecutiveOfficer(data) {
    return _.includes(data.roles, 'executive_officer');
  },

  _isBidder(data) {
    return _.isEqual(data.roles, ['bidder']);
  },

  _isEvaluator(data) {
    return _.isEqual(data.roles, ['evaluator']);
  },

  _tenderNameRenderer(row) {
    return `<a href='${this._tenderUrl(row.data)}'><b>${row.data.name}</b></a>`;
  },

  _tenderNameComparator(valueA, valueB, nodeA, nodeB) {
    return WorkplaceUtils.compareNodeStrings(valueA, valueB, nodeA, nodeB, 'name');
  },

  _stateRenderer(row) {
    return `<div class='document-status status-label label-tender-status ${WorkplaceUtils.dasherize(row.data.state)}'>` + row.data.formatted_state + "</div>";
  },

  _stateComparator(valueA, valueB, nodeA, nodeB) {
    return WorkplaceUtils.compareNodeStrings(valueA, valueB, nodeA, nodeB, 'state');
  },

  _updatedAtDateComparator(valueA, valueB, nodeA, nodeB) {
    return nodeA.data['updated_at'] - nodeB.data['updated_at'];
  },

  _createdAtDateComparator(valueA, valueB, nodeA, nodeB) {
    return nodeA.data['created_at'] - nodeB.data['created_at'];
  },

  _biddingStartsAtRenderer(row) {
    if (row.data.state === 'draft') { return; }
    const m = moment(row.data.formatted_bidding_starts_at);
    if (m.isValid()) { return m.format('MMM DD, YYYY - hh:mm A'); } else { return ''; }
  },

  _biddingStartsAtDateComparator(valueA, valueB, nodeA, nodeB) {
    return nodeA.data['bidding_starts_at'] - nodeB.data['bidding_starts_at'];
  },

  _originalBiddingEndsAtRenderer(row) {
    if (row.data.state === 'draft') { return; }
    const m = moment(row.data.original_formatted_bidding_ends_at);
    if (m.isValid()) { return m.format('MMM DD, YYYY - hh:mm A'); } else { return ''; }
  },

  _originalBiddingEndsAtDateComparator(valueA, valueB, nodeA, nodeB) {
    return nodeA.data['original_bidding_ends_at'] - nodeB.data['original_bidding_ends_at'];
  },

  _biddingEndsAtRenderer(row) {
    if (row.data.state === 'draft') { return; }
    const m = moment(row.data.formatted_bidding_ends_at);
    if (m.isValid()) { return m.format('MMM DD, YYYY - hh:mm A'); } else { return ''; }
  },

  _biddingEndtsAtDateComparator(valueA, valueB, nodeA, nodeB) {
    return nodeA.data['bidding_ends_at'] - nodeB.data['bidding_ends_at'];
  },

  _projectCreatedAtDateComparator(valueA, valueB, nodeA, nodeB) {
    return nodeA.data['project_created_at'] - nodeB.data['project_created_at'];
  },

  _latestRfcDateComparator(valueA, valueB, nodeA, nodeB) {
    // Get the role-specific field for comparison
    const isAdminA = this._isUserAdmin(nodeA.data.company_admin_or_auditor_ids);
    const userRoleA = this._findCurrentUserRole(nodeA.data.roles_with_users, isAdminA);

    const isAdminB = this._isUserAdmin(nodeB.data.company_admin_or_auditor_ids);
    const userRoleB = this._findCurrentUserRole(nodeB.data.roles_with_users, isAdminB);

    // Determine which field to use based on role
    let fieldA = 'latest_rfc_created_at';
    let fieldB = 'latest_rfc_created_at';

    if (userRoleA === 'documenter') {
      fieldA = 'latest_rfc_documenter_created_at';
    } else if (userRoleA === 'verifier') {
      fieldA = 'latest_rfc_verifier_created_at';
    }

    if (userRoleB === 'documenter') {
      fieldB = 'latest_rfc_documenter_created_at';
    } else if (userRoleB === 'verifier') {
      fieldB = 'latest_rfc_verifier_created_at';
    }

    const timeA = nodeA.data[fieldA] || 0;
    const timeB = nodeB.data[fieldB] || 0;

    return timeA - timeB;
  },

  _latestRfcCommentDateComparator(valueA, valueB, nodeA, nodeB) {
    // Get the role-specific field for comparison
    const isAdminA = this._isUserAdmin(nodeA.data.company_admin_or_auditor_ids);
    const userRoleA = this._findCurrentUserRole(nodeA.data.roles_with_users, isAdminA);

    const isAdminB = this._isUserAdmin(nodeB.data.company_admin_or_auditor_ids);
    const userRoleB = this._findCurrentUserRole(nodeB.data.roles_with_users, isAdminB);

    // Determine which field to use based on role
    let fieldA = 'latest_rfc_comment_created_at';
    let fieldB = 'latest_rfc_comment_created_at';

    if (userRoleA === 'documenter') {
      fieldA = 'latest_rfc_comment_documenter_created_at';
    } else if (userRoleA === 'verifier') {
      fieldA = 'latest_rfc_comment_verifier_created_at';
    }

    if (userRoleB === 'documenter') {
      fieldB = 'latest_rfc_comment_documenter_created_at';
    } else if (userRoleB === 'verifier') {
      fieldB = 'latest_rfc_comment_verifier_created_at';
    }

    const timeA = nodeA.data[fieldA] || 0;
    const timeB = nodeB.data[fieldB] || 0;

    return timeA - timeB;
  },

  // Find current user's role from rolesWithUsers array
  // Priority: executive_officer > evaluator > auditor > verifier > documenter > bidder
  // User qualifies for a role if:
  //   1. They are in that role's user_ids, OR
  //   2. They are admin and that role exists in the company
  _findCurrentUserRole(rolesWithUsers, isAdmin) {
    // Validate inputs
    const currentUserId = window.currentUserId;
    if (!currentUserId || !rolesWithUsers || !Array.isArray(rolesWithUsers) || rolesWithUsers.length === 0) {
      return null;
    }

    // Role priority order - highest priority first
    const rolePriority = ['executive_officer', 'evaluator', 'auditor', 'verifier', 'documenter', 'bidder'];

    // IMPORTANT: First check if user is DIRECTLY in any role (not just admin)
    // This ensures we use the correct RFC data for the user's actual role in this tender
    for (const role of rolePriority) {
      const roleEntry = rolesWithUsers.find(r => r && r.role === role);
      if (roleEntry) {
        const userInRole = Array.isArray(roleEntry.user_ids) && roleEntry.user_ids.includes(currentUserId);
        if (userInRole) {
          // User is directly in this role - return it immediately
          return role;
        }
      }
    }

    // FALLBACK: If user is NOT directly in any role but IS admin,
    // they get the highest priority role available
    if (isAdmin) {
      for (const role of rolePriority) {
        const roleEntry = rolesWithUsers.find(r => r && r.role === role);
        if (roleEntry) {
          return role;
        }
      }
    }

    return null;
  },

  // Get all roles the current user qualifies for (for multi-role users)
  _findAllUserRoles(rolesWithUsers, isAdmin) {
    // Validate inputs
    const currentUserId = window.currentUserId;
    if (!currentUserId || !rolesWithUsers || !Array.isArray(rolesWithUsers) || rolesWithUsers.length === 0) {
      return [];
    }

    const userRoles = [];

    // Check all roles
    rolesWithUsers.forEach(roleEntry => {
      if (roleEntry && roleEntry.role) {
        const userInRole = Array.isArray(roleEntry.user_ids) && roleEntry.user_ids.includes(currentUserId);
        if (userInRole || isAdmin) {
          userRoles.push(roleEntry.role);
        }
      }
    });

    return userRoles;
  },

  // Get RFC data based on user's roles with priority
  // If user has multiple roles, return data for highest priority role
  // Admin gets RFC access according to their role priority
  _getRfcDataForUser(rowData) {
    if (!rowData) {
      return null;
    }

    const currentUserId = window.currentUserId;
    if (!currentUserId || !rowData.roles_with_users) {
      return null;
    }

    // Check if user is admin/auditor of this company
    const isAdmin = this._isUserAdmin(rowData.company_admin_or_auditor_ids);

    // Check if company has executive_officer role in this tender
    const hasExecutiveOfficerRole = rowData.roles_with_users.some(
      r => r && r.role === 'executive_officer'
    );

    // PRIORITY 1: Admin of executive_officer company sees ALL RFCs
    // (Admin + company has EO role = sees all)
    if (isAdmin && hasExecutiveOfficerRole) {
      return rowData.rfc || null;
    }

    // PRIORITY 2: Check user's actual role in this tender (via roles_with_users)
    for (const roleEntry of rowData.roles_with_users) {
      if (!roleEntry || !roleEntry.role || !Array.isArray(roleEntry.user_ids)) {
        continue;
      }

      // Check if current user is in this role
      const userInThisRole = roleEntry.user_ids.includes(currentUserId);
      if (!userInThisRole) {
        continue;  // User not in this role - try next role
      }

      // User is directly in this role - use the appropriate RFC field
      if (roleEntry.role === 'verifier') {
        return rowData.rfc_verifier || null;
      } else if (roleEntry.role === 'documenter') {
        return rowData.rfc_documenter || null;
      } else if (roleEntry.role === 'executive_officer' || roleEntry.role === 'auditor' || roleEntry.role === 'evaluator') {
        // Executive officer, auditor, and evaluator see all RFCs
        return rowData.rfc || null;
      } else {
        // Other roles (bidder, etc) - use generic field
        return rowData.rfc || null;
      }
    }

    // User doesn't have a role in this tender - shouldn't see it
    return null;
  },

  // Check if tender should be shown when "Open RFCs" filter is active
  // This uses the role-specific open_rfcs field for the user's role in THIS tender
  _shouldShowTenderWithOpenRfcsFilter(rowData) {
    if (!rowData) {
      return false;
    }

    // Check if user is admin of this company
    const isAdmin = this._isUserAdmin(rowData.company_admin_or_auditor_ids);

    // Get the highest priority role (admin status is considered)
    const userRole = this._findCurrentUserRole(rowData.roles_with_users, isAdmin);

    // Check the role-specific open_rfcs field
    if (userRole === 'verifier' && rowData.open_rfcs_verifier !== undefined) {
      return rowData.open_rfcs_verifier === true;
    } else if (userRole === 'documenter' && rowData.open_rfcs_documenter !== undefined) {
      return rowData.open_rfcs_documenter === true;
    } else {
      // executive_officer, auditor, evaluator, bidder - use generic field
      return rowData.open_rfcs === true;
    }
  },

  // Check if current user is admin/auditor/evaluator
  _isUserAdmin(adminIds) {
    // Validate inputs
    const currentUserId = window.currentUserId;
    if (!currentUserId || !adminIds || !Array.isArray(adminIds)) {
      return false;
    }

    return adminIds.includes(currentUserId);
  },

  _rfcRenderer(data) {
    // Select the appropriate RFC data based on user's highest priority role
    // Admin status is checked to determine role eligibility
    const rowData = data.data;

    // Check if user is admin of this company - this affects role eligibility
    const isAdmin = this._isUserAdmin(rowData.company_admin_or_auditor_ids);

    // Get the highest priority role (admin status is considered)
    const userRole = this._findCurrentUserRole(rowData.roles_with_users, isAdmin);

    // Get RFC data for this role
    const rfc = this._getRfcDataForUser(rowData);

    return `<div>${this._rfcText(rfc, rowData)}</div>`;
  },

  _rfcText(rfc, rowData) {
    // RFC data is already role-specific and selected by _rfcRenderer
    // Just extract and display the counts

    let count = 0;
    let closed_count = 0;

    // Safely extract counts from the RFC object
    if (rfc && typeof rfc === 'object') {
      count = parseInt(rfc.count, 10) || 0;
      closed_count = parseInt(rfc.closed_count, 10) || 0;
    }

    const color = ((count !== 0) && (closed_count === count)) ? 'complete' : 'incomplete';
    return `<div class='data-count ${color}'>${closed_count}</div> / ${count}`;
  },

  _bidStateRenderer(data) {
    if (!data.value) { return '-'; }
    return WorkplaceUtils.capitalize(data.value);
  },

  _numberComparator(valueA, valueB) {
    return (valueA || { count: -1 }).count - (valueB || { count: -1 }).count;
  },

  _noBiddersInvitedComparator(valueA, valueB, nodeA, nodeB) {
    return (nodeA.data || { bidders_invited_count: -1 }).bidders_invited_count -
      (nodeB.data || { bidders_invited_count: -1 }).bidders_invited_count;
  },

  _noBiddersAcceptedComparator(valueA, valueB, nodeA, nodeB) {
    return (nodeA.data || { bidders_accepted_count: -1 }).bidders_accepted_count -
      (nodeB.data || { bidders_accepted_count: -1 }).bidders_accepted_count;
  },

  _noBidsReceivedComparator(valueA, valueB, nodeA, nodeB) {
    return (nodeA.data || { bids_submitted_count: -1 }).bids_submitted_count -
      (nodeB.data || { bids_submitted_count: -1 }).bids_submitted_count;
  },

  _phaseDocumentSetUrl(row) {
    return `/workplace/projects/${row.data.project_slug}/phases/${row.data.phase_slug}/document_sets`;
  },

  _phaseTendersUrl(row) {
    return `/workplace/projects/${row.data.project_slug}/phases/${row.data.phase_slug}/tenders`;
  },

  _phaseRenderer(row) {
    if (this._isBidder(row.data)) {
      return `<a href='${this._phaseTendersUrl(row)}'>${row.data.phase}</a>`;
    } else {
      return `<a href='${this._phaseDocumentSetUrl(row)}'>${row.data.phase}</a>`;
    }
  },

  _projectRenderer(row) {
    if (this._isBidder(row.data)) {
      return `<a href='${this._phaseTendersUrl(row)}'>${row.data.project}</a>`;
    } else {
      return `<a href='${this._phaseDocumentSetUrl(row)}'>${row.data.project}</a>`;
    }
  },

  _biddersInvitedRenderer(row) {
    if (!row.value) { return '-'; }
    return `<div> ${row.value}</div>`;
  },

  _biddersAcceptedRenderer(row) {
    if (!row.value) { return '-'; }
    return `<div> ${row.value}</div>`;
  },

  _latestRfcRenderer(row) {
    // Get role-aware RFC field based on user's highest priority role
    const rowData = row.data;
    if (!rowData) { return '-'; }

    // Check if user is admin of this company
    const isAdmin = this._isUserAdmin(rowData.company_admin_or_auditor_ids);

    // Get the highest priority role (admin status is considered)
    const userRole = this._findCurrentUserRole(rowData.roles_with_users, isAdmin);

    // Select the role-specific field
    let value = null;
    if (userRole === 'documenter' && rowData.formatted_latest_rfc_documenter_created_at) {
      value = rowData.formatted_latest_rfc_documenter_created_at;
    } else if (userRole === 'verifier' && rowData.formatted_latest_rfc_verifier_created_at) {
      value = rowData.formatted_latest_rfc_verifier_created_at;
    } else {
      // executive_officer, auditor, evaluator, bidder - use generic field
      value = rowData.formatted_latest_rfc_created_at;
    }

    if (!value) { return '-'; }
    return `<div> ${value}</div>`;
  },

  _latestRfcCommentRenderer(row) {
    // Get role-aware RFC comment field based on user's highest priority role
    const rowData = row.data;
    if (!rowData) { return '-'; }

    // Check if user is admin of this company
    const isAdmin = this._isUserAdmin(rowData.company_admin_or_auditor_ids);

    // Get the highest priority role (admin status is considered)
    const userRole = this._findCurrentUserRole(rowData.roles_with_users, isAdmin);

    // Select the role-specific field
    let value = null;
    if (userRole === 'documenter' && rowData.formatted_latest_rfc_comment_documenter_created_at) {
      value = rowData.formatted_latest_rfc_comment_documenter_created_at;
    } else if (userRole === 'verifier' && rowData.formatted_latest_rfc_comment_verifier_created_at) {
      value = rowData.formatted_latest_rfc_comment_verifier_created_at;
    } else {
      // executive_officer, auditor, evaluator, bidder - use generic field
      value = rowData.formatted_latest_rfc_comment_created_at;
    }

    if (!value) { return '-'; }
    return `<div> ${value}</div>`;
  },

  _defaultNumberRenderer(row) {
    if (!row.value) { return '-'; }
    return `<div> ${row.value}</div>`;
  },

  _evaluationsSummaryRenderer(params) {
    if (!params.data.evaluations_count) { return '-'; }
    const color = (params.data.evaluations_done === params.data.evaluations_count) ? 'complete' : 'incomplete';
    return `<div>${params.data.evaluations_done} / <div class='data-count ${color}'>${params.data.evaluations_count}</div></div>`;
  },

  _bidsRenderer(params) {
    if (!params.data.bids_submitted_count) { return '-'; }
    return `<div>${this._bidsText(params)}</div>`;
  },

  _bidsText(params) {
    if (!params.data.bids_submitted_count) { return ''; }
    const color = ((params.data.bidders_invited_count !== 0) && (params.data.bids_submitted_count >= params.data.bids_min_count)) ? 'complete' : 'incomplete';
    return `${params.data.bidders_invited_count} / ${params.data.bidders_accepted_count} / <div class='data-count ${color}'>${params.data.bids_submitted_count}</div>`;
  },

  _bidsReceivedRenderer(row) {
    if (!row.value) { return '-'; }
    const color = ((row.data.bidders_invited_count !== 0) && (row.value >= row.data.min_count)) ? 'complete' : 'incomplete';
    return `<div class='data-count ${color}'>${row.value}</div>`;
  },

  _eotTenderClosingDate(row) {
    if (!row.value) { return '-'; }
    return `<div>${row.value} ${I18n.t('v4.tenders.workplace_index.days')}</div>`;
  },

  initializeTable(app_id, key, index, preloadedCookies) {
    this._tenderSearch = SearchUtils.createInstantSearch(app_id, key, index);


    this._initializeWidgets(app_id, key, index);
    this._tenderSearch.addWidgets([
      instantsearch.widgets.configure({ hitsPerPage: 20000 }),
      WorkplaceWidgets.tendersHitsWidget()({})
    ]);
    this._tenderSearch.start();

    this._initializeSaveSearch();
    const containerWidth = $('.content-wrapper.search-results-container').width();
    const minTenderGroupWidth = containerWidth * 0.65;
    const minProjectGroupWidth = containerWidth * 0.35;

    const columnDefs =
      [
        {
          headerName: I18n.t('v4.tenders.workplace_index.headers.tender'),
          children: [
            { headerName: I18n.t('v4.tenders.workplace_index.headers.tender_name'), width: 500, minWidth: minTenderGroupWidth * 0.10, tooltipField: 'name', cellRenderer: _.bind(this._tenderNameRenderer, this), comparator: _.bind(this._tenderNameComparator, this) },
            { headerName: I18n.t('v4.tenders.workplace_index.headers.ref_no'), width: 200, minWidth: minTenderGroupWidth * 0.05, field: 'reference' },
            { headerName: I18n.t('v4.tenders.workplace_index.headers.tender_status'), field: 'state', minWidth: minTenderGroupWidth * 0.1, cellRenderer: this._stateRenderer, comparator: _.bind(this._stateComparator, this) },
            { headerName: 'Create', field: 'formatted_created_at', minWidth: minTenderGroupWidth * 0.1, comparator: _.bind(this._createdAtDateComparator, this) },
            { headerName: 'Update', field: 'formatted_updated_at', minWidth: minTenderGroupWidth * 0.1, comparator: _.bind(this._updatedAtDateComparator, this) }
          ]
        },
        {
          headerName: I18n.t('v4.tenders.workplace_index.headers.posting'),
          children: [
            { headerName: I18n.t('v4.tenders.workplace_index.headers.bidding_starts_at'), field: 'formatted_bidding_starts_at', minWidth: minTenderGroupWidth * 0.05, cellRenderer: this._biddingStartsAtRenderer, comparator: _.bind(this._biddingStartsAtDateComparator, this) },
            { headerName: I18n.t('v4.tenders.workplace_index.headers.original_bidding_ends_at'), field: 'original_formatted_bidding_ends_at', minWidth: minTenderGroupWidth * 0.05, cellRenderer: this._originalBiddingEndsAtRenderer, comparator: _.bind(this._originalBiddingEndsAtDateComparator, this) },
            { headerName: I18n.t('v4.tenders.workplace_index.headers.actual_bidding_ends_at'), field: 'formatted_bidding_ends_at', minWidth: minTenderGroupWidth * 0.05, cellRenderer: this._biddingEndsAtRenderer, comparator: _.bind(this._biddingEndtsAtDateComparator, this) },
          ]
        },
        {
          headerName: I18n.t('v4.tenders.workplace_index.headers.bids'),
          children: [
            { headerName: I18n.t('v4.tenders.workplace_index.headers.no_bidders_invited'), width: 130, minWidth: minTenderGroupWidth * 0.05, field: 'bidders_invited_count', cellRenderer: this._biddersInvitedRenderer, comparator: this._noBiddersInvitedComparator },
            { headerName: I18n.t('v4.tenders.workplace_index.headers.no_bidders_accepted'), width: 130, minWidth: minTenderGroupWidth * 0.05, field: 'bidders_accepted_count', cellRenderer: this._biddersAcceptedRenderer, comparator: this._noBiddersAcceptedComparator },
            { headerName: I18n.t('v4.tenders.workplace_index.headers.no_bids_received'), width: 130, minWidth: minTenderGroupWidth * 0.05, field: 'bids_submitted_count', cellRenderer: this._bidsReceivedRenderer, comparator: this._noBidsReceivedComparator },
            { headerName: I18n.t('v4.tenders.workplace_index.headers.bid_status'), field: 'bid_state', minWidth: minTenderGroupWidth * 0.05, cellRenderer: this._bidStateRenderer },
            { headerName: I18n.t('v4.tenders.workplace_index.headers.bids_summary'), colId: 'bids_summary', width: 130, cellRenderer: _.bind(this._bidsRenderer, this), comparator: this._numberComparator },
          ]
        },
        {
          headerName: I18n.t('v4.tenders.workplace_index.headers.rfcs'),
          children: [
            { headerName: I18n.t('v4.tenders.workplace_index.headers.rfcs'), width: 130, minWidth: minTenderGroupWidth * 0.05, colId: 'rfc_display', cellRenderer: _.bind(this._rfcRenderer, this), comparator: this._numberComparator },
            { headerName: I18n.t('v4.tenders.workplace_index.headers.latest_rfc'), field: 'formatted_latest_rfc_created_at', colId: 'latest_rfc_created_at', minWidth: minTenderGroupWidth * 0.05, cellRenderer: _.bind(this._latestRfcRenderer, this), comparator: this._latestRfcDateComparator },
            { headerName: I18n.t('v4.tenders.workplace_index.headers.latest_rfc_comment'), field: 'formatted_latest_rfc_comment_created_at', colId: 'latest_rfc_comment_created_at', minWidth: minTenderGroupWidth * 0.05, cellRenderer: _.bind(this._latestRfcCommentRenderer, this), comparator: this._latestRfcCommentDateComparator }
          ]
        },
        {
          headerName: I18n.t('v4.tenders.workplace_index.headers.project'),
          children: [
            { headerName: I18n.t('v4.tenders.workplace_index.headers.project_name'), width: 400, minWidth: minProjectGroupWidth * 0.25, field: 'project', tooltipField: 'project', cellRenderer: _.bind(this._projectRenderer, this) },
            { headerName: I18n.t('v4.tenders.workplace_index.headers.project_reference'), width: 200, minWidth: minProjectGroupWidth * 0.15, field: 'project_reference' },
            { headerName: 'Create', field: 'formatted_project_created_at', minWidth: minProjectGroupWidth * 0.24, comparator: _.bind(this._projectCreatedAtDateComparator, this) },
            { headerName: I18n.t('v4.tenders.workplace_index.headers.phase'), field: 'phase', minWidth: minProjectGroupWidth * 0.20, cellRenderer: _.bind(this._phaseRenderer, this) },
            { headerName: I18n.t('v4.tenders.workplace_index.headers.location'), field: 'location_text', minWidth: minProjectGroupWidth * 0.15 },
          ]
        }, {
          headerName: I18n.t('v4.tenders.workplace_index.headers.evaluations'),
          children: [
            { headerName: I18n.t('v4.tenders.workplace_index.headers.evaluations_done'), width: 200, minWidth: minProjectGroupWidth * 0.15, field: 'evaluations_done', comparator: this._numberComparator, cellRenderer: this._defaultNumberRenderer },
            { headerName: I18n.t('v4.tenders.workplace_index.headers.evaluations_all'), width: 200, minWidth: minProjectGroupWidth * 0.15, field: 'evaluations_count', comparator: this._numberComparator, cellRenderer: this._defaultNumberRenderer },
            { headerName: I18n.t('v4.tenders.workplace_index.headers.evaluations_summary'), colId: 'evaluation_summary', width: 200, minWidth: minProjectGroupWidth * 0.15, cellRenderer: this._evaluationsSummaryRenderer, comparator: this._numberComparator }
          ]
        }
      ];

    this._gridOptions = {
      paginationPageSize: 48,
      headerHeight: 44,
      rowHeight: 44,
      rowStyle: { overflow: 'hidden' },
      pagination: true,
      suppressPaginationPanel: true,
      columnDefs,
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      onGridReady(e) {
        return e.api.sizeColumnsToFit();
      },
      onGridSizeChanged(event) {
        return event.api.sizeColumnsToFit();
      }
    };
    const agGridPagination = AgGridPagination.initialize(this._gridOptions);
    this._gridOptions.onPaginationChanged = agGridPagination.renderPagination.bind(agGridPagination);

    $('#pagination').exists().on('click', () => {
      var pageSize = this._gridApi.paginationGetPageSize();
      var currentPage = this._gridApi.paginationGetCurrentPage();
      var totalRows = this._gridApi.paginationGetRowCount();
      this._currentDataSize = Math.min(pageSize, totalRows - (currentPage * pageSize));
      return this._resizeTable();
    });

    const gridDiv = document.getElementById('tenders-table');
    // v35: createGrid replaces new agGrid.Grid()
    this._gridApi = agGrid.createGrid(gridDiv, this._gridOptions);
    // Store api on gridOptions for backward compatibility with shared components
    this._gridOptions.api = this._gridApi;
    this._initializeCookieSavers(preloadedCookies, '/workplace');
    AgGridColumnFilters.initialize(this._gridOptions, ['bids_summary', 'bid_state', 'location_text', 'evaluation_summary']);
    return AgGridPagination.initializePaginationListeners();
  },

  initializeList(app_id, key, index) {
    this._tenderSearch = SearchUtils.createInstantSearch(app_id, key, index);


    this._initializeWidgets(app_id, key, index);
    this._tenderSearch.addWidgets([this._tendersListHitsWidget()]);
    this._tenderSearch.start();
    infiniteHits.loadMoreResults();
    return this._initializeSaveSearch();
  },

  initializeDashboardList(indexParams, sortByIndices) {
    this._tenderSearch = SearchUtils.createInstantSearch(indexParams.appId, indexParams.key, indexParams.name);

    this._tenderSearch.addWidgets([
      this._tendersListInfiniteHitsWidget()
    ]);
    if ($('#sort-by-container').length > 0) { this._tenderSearch.addWidgets([this._sortBySelectorWidget(sortByIndices)]); }
    this._tenderSearch.start();
    return infiniteHits.loadMoreResults();
  },

  _sortBySelectorWidget(sortByIndices) {
    return instantsearch.widgets.sortBy({
      container: '#sort-by-container',
      items: sortByIndices
    });
  },

  _tendersListInfiniteHitsWidget() {
    const self = this;
    return instantsearch.widgets.infiniteHits({
      container: '#tenders-grid',
      templates: {
        item: $('#tender-template').text(),
        empty: $('#no-search-results-found-template').text()
      },
      cssClasses: {
        root: 'ais-Hits',
        list: 'ais-Hits-list list-view grid items borders',
        item: 'item'
      },
      transformItems: items => {
        items = items.map(item => {
          item.path = self._tenderUrl(item);
          item.bidsText = self._bidsText({ data: item });
          // Get RFC data based on user's highest priority role
          const rfc = self._getRfcDataForUser(item);
          item.rfcText = self._rfcText(rfc, item);
          item.projectText = self._projectRenderer({ data: item });
          return item;
        });

        // Note: Client-side Open RFCs filtering is now handled by the checkbox widget
        // which directly manipulates the DOM based on _shouldShowTenderWithOpenRfcsFilter

        return items;
      }
    });
  },

  _tendersListHitsWidget() {
    const self = this;
    return instantsearch.widgets.infiniteHits({
      container: '#tenders-grid',
      templates: {
        item: $('#tender-template').text(),
        empty: $('#no-search-results-found-template').text()
      },
      cssClasses: {
        root: 'ais-Hits',
        item: 'item',
        list: 'list-view grid items borders ais-Hits-list'
      },
      transformItems: items => {
        items = items.map(item => {
          item.path = self._tenderUrl(item);
          item.bidsText = self._bidsText({ data: item });
          // Get RFC data based on user's highest priority role
          const rfc = self._getRfcDataForUser(item);
          item.rfcText = self._rfcText(rfc, item);
          item.projectText = self._projectRenderer({ data: item });
          return item;
        });

        // Note: Client-side Open RFCs filtering is now handled by the checkbox widget
        // which directly manipulates the DOM based on _shouldShowTenderWithOpenRfcsFilter

        return items;
      }
    });
  }
};

window.CreateTenderModal = {
  initialize(phases) {
    $('#select_tender_project').exists().selectize({ plugins: ['remove_button'] });
    const phasesSelect = $('#select_tender_project_phase').exists().selectize({ plugins: ['remove_button'] })[0].selectize;
    $('#select_tender_project, #select_tender_project_phase').next().css('display', 'none');

    $('input[name=tender_within_new_project]').on('change', function () {
      if ($(this).val() === 'true') {
        $('#select_tender_project, #select_tender_project_phase').next().css('display', 'none');
        $('#create-tender-continue-button').attr('href', '/workplace/projects/new');
        return $('#create-tender-continue-button').removeAttr('disabled');
      } else {
        $('#select_tender_project, #select_tender_project_phase').next().css('display', 'block');
        const project_id = $('#select_tender_project').val();
        if (project_id !== '') {
          const project_phases = _.where(phases, { project_id })[0].phases;
          const phase_id = project_phases[0].slug;
          const href = "/workplace/projects/" + project_id + "/phases/" + phase_id + "/tenders/new";
          $('#create-tender-continue-button').attr('href', href);
          return $('#create-tender-continue-button').removeAttr('disabled');
        } else {
          return $('#create-tender-continue-button').attr('disabled', 'disabled');
        }
      }
    });

    $('#select_tender_project').on('change', function () {
      const project_id = $('#select_tender_project').val();

      if (project_id !== '') {
        const project_phases = _.where(phases, { project_id: parseInt(project_id) })[0].phases;
        phasesSelect.clearOptions();
        phasesSelect.addOption(_.map(project_phases, phase => ({
          value: phase.slug,
          text: phase.name
        })));
        phasesSelect.refreshOptions();
        if (project_phases.length === 1) {
          const phase_id = project_phases[0].slug;
          phasesSelect.setValue(phase_id);
          const href = "/workplace/projects/" + project_id + "/phases/" + phase_id + "/tenders/new";
          $('#create-tender-continue-button').attr('href', href);
          return $('#create-tender-continue-button').removeAttr('disabled');
        }
      } else {
        phasesSelect.clearOptions();
        return $('#create-tender-continue-button').attr('disabled', 'disabled');
      }
    });

    return $('#select_tender_project_phase').on('change', function () {
      const phase_id = $('#select_tender_project_phase').val();
      const project_id = $('#select_tender_project').val();
      if (phase_id !== '') {
        const href = "/workplace/projects/" + project_id + "/phases/" + phase_id + "/tenders/new";
        $('#create-tender-continue-button').attr('href', href);
        return $('#create-tender-continue-button').removeAttr('disabled');
      } else {
        return $('#create-tender-continue-button').attr('disabled', 'disabled');
      }
    });
  }
};
